import React from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image"
import styles from "./ArticleRow.module.css"

const ArticleRow = ({ imageSrc, imageAlt, rowContent, isReversed, className = "", imageMaxWidth = null}) => {
  let imageStyle = {};
  if (imageMaxWidth) {
    imageStyle.maxWidth = imageMaxWidth
  }

  return (
    <article className={`${styles.row} ${isReversed ? styles.reversed : ""} ${className ? styles[className] : ""}`}>
      <figure className={styles.rowImage} style={imageStyle}>
        {imageSrc && <Img fluid={imageSrc} alt={imageAlt}/>}
      </figure>
      <div className={styles.rowContent}>
        {rowContent}
      </div>
    </article>
  )
}

ArticleRow.propTypes = {
  imageSrc: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  imageAlt: PropTypes.string.isRequired,
  rowContent: PropTypes.any.isRequired,
  isReversed: PropTypes.bool,
  className: PropTypes.string,
  imageMaxWidth: PropTypes.number,
}

export default ArticleRow